import React from 'react';

interface LineProps {
  color: string,
}
export const Line: React.FC<LineProps> = ({
  color,
}: LineProps) => (
  <div className="line" style={{ borderColor: color }} />
);
